import "./Spinner.css";
const Spinner = ({ className }) => (
  <div className={`sw-loader ${className}`}></div>
);

export default Spinner;
